export const getLoginPath = () => '/';

export const getHomePath = () => '/home';

/** Set on `/home` after a successful office check-in to open the success modal. */
export const HOME_CHECKED_IN_QUERY = 'checkedIn';

export const getHomeAfterCheckInPath = () =>
  `${getHomePath()}?${HOME_CHECKED_IN_QUERY}=1`;

export const getSealsProgramDescriptionPath = () => '/programs/seals';
export const getSealsAppPath = () => '/programs/seals/application';
export const getSealsAppBackgroundPath = () =>
  '/programs/seals/application/background';
export const getSealsAppSchoolPath = () =>
  '/programs/seals/application/school';
export const getSealsAppFamilyPath = () =>
  '/programs/seals/application/family';
export const getSealsAppPromptsPath = () =>
  '/programs/seals/application/prompts';
export const getSealsAppTranscriptsPath = () =>
  '/programs/seals/application/transcripts';
export const getSealsAppSignaturePath = () =>
  '/programs/seals/application/signature';

const SCLA_APPLICATION_BASE = '/scla-application';

export const getSclaAppHomePath = () => `${SCLA_APPLICATION_BASE}/home`;

export function withSclaCohortYear(path: string, cohortYear: string) {
  const params = new URLSearchParams({ cohortYear });
  return `${path}?${params.toString()}`;
}
export const getSclaAppBackgroundPath = () => `${SCLA_APPLICATION_BASE}/background`;
export const getSclaAppSchoolPath = () => `${SCLA_APPLICATION_BASE}/school`;
export const getSclaAppFamilyPath = () => `${SCLA_APPLICATION_BASE}/family`;
export const getSclaAppPromptsPath = () => `${SCLA_APPLICATION_BASE}/prompts`;
export const getSclaAppTranscriptsPath = () => `${SCLA_APPLICATION_BASE}/transcripts`;
export const getSclaAppRecPath = () => `${SCLA_APPLICATION_BASE}/rec`;
export const getSclaAppSignaturePath = () => `${SCLA_APPLICATION_BASE}/signature`;

export const getSclaTeamRosterPath = () => '/scla/team';

export const getFormsListPath = () => '/forms';
export const getFormSignPath = (assignmentId: string) =>
  `/forms/${assignmentId}`;

export const getTxtTrainingCoursesPath = () => '/txt-training';
export const getTxtTrainingCourseTakePath = (courseId: string) =>
  `/txt-training/${courseId}`;
export const getTxtTrainingLessonPath = (
  courseId: string,
  moduleId: string,
  lessonId: string,
) => `/txt-training/${courseId}/module/${moduleId}/lesson/${lessonId}`;

export const getTxtLabsApprenticeshipDescriptionPath = () =>
  '/txt-labs/apprenticeship';
export const getTxtLabsApprenticeshipAppPath = () =>
  '/txt-labs/apprenticeship/application';

export const getAiImageChatPath = () => '/ai-image-chat';

export const getOfficeCheckInPath = () => '/office/check-in';
export const getOfficeCheckOutPath = () => '/office/check-out';

export const getUpdateProfilePath = (
  returnTo?: string,
  sectionAnchor?: string,
) => {
  const hash = sectionAnchor ? `#${sectionAnchor}` : '';
  if (!returnTo) return `/profile${hash}`;
  const params = new URLSearchParams({ returnTo });
  return `/profile?${params.toString()}${hash}`;
};

/** Safe in-app redirect after profile save (`returnTo` query). */
export const resolveProfileReturnTo = (
  returnTo: string | null | undefined,
): string | null => {
  if (
    !returnTo ||
    !returnTo.startsWith('/') ||
    returnTo.startsWith('//')
  ) {
    return null;
  }
  return returnTo;
};

export const getOfficeCheckInEditProfilePath = (
  source?: string | null,
  sectionAnchor?: string,
) => {
  const returnPath = source
    ? `${getOfficeCheckInPath()}?source=${encodeURIComponent(source)}`
    : getOfficeCheckInPath();
  return getUpdateProfilePath(returnPath, sectionAnchor);
};

// SCLA mobile applications (scla-2026-mothership student apps)
export const getSclaMobileApplicationsPath = () =>
  '/scla/mobile-applications';
export const getSclaMobileApplicationsPriceHistoryPath = () =>
  '/scla/mobile-applications/price-history';
/** @deprecated Prefer getSclaMobileApplicationsPath */
export const getMothershipAdminPath = getSclaMobileApplicationsPath;

// IndieCardz-only mothership admin surfaces (team grant must be indie-cardz).
export const getIndieCardzStoresPath = () =>
  '/scla/mobile-applications/stores';
export const getIndieCardzStoreDetailPath = (storeId: string) =>
  `/scla/mobile-applications/stores/${storeId}`;
export const getIndieCardzOrdersPath = () =>
  '/scla/mobile-applications/orders';
